
    import "src/shared/components/DriverInfoSlider/index.module.scss?farm_css_modules";
    
    export default {"main": `main-8490997c`,"open": `open-8490997c`,"orderInfoContainer": `orderInfoContainer-8490997c`,"paddedRow": `paddedRow-8490997c`,"row1": `row1-8490997c`}
    